import { Client } from "@stomp/stompjs";
import SockJS from "sockjs-client";
import { genAIWebsocket } from "../constant/Constant";

const baseUrl = process.env.REACT_APP_BACKEND_URL;

class WebSocketService {
  client = null;

  connectWS(url = `${baseUrl}${genAIWebsocket}`) {
    return new Promise((resolve, reject) => {
      const stompClient = new Client({
        webSocketFactory: () => new SockJS(url),
        reconnectDelay: 0, // no reconnect for deterministic behavior
        debug: () => {},
        onConnect: () => resolve(stompClient),
        onStompError: reject,
        onWebSocketError: reject,
      });

      this.client = stompClient;
      stompClient.activate();
    });
  }

  subscribe(topic, callback) {
    if (!this.client || !this.client.connected) return null;

    return this.client.subscribe(topic, (msg) => {
      callback(msg.body);
    });
  }

  disconnect() {
    if (this.client) this.client.deactivate();
  }

  send(destination, payload, headers = {}) {
    if (!this.client || !this.client.connected) {
      console.error("WebSocket not connected");
      return;
    }

    this.client.publish({
      destination,
      body: JSON.stringify(payload),
      headers,
    });
  }
}

export default new WebSocketService();
